var initialState = {
  active: false,
  message: null,
  severity: null
};
export default function (state, action) {
  if (state === void 0) {
    state = initialState;
  }
  switch (action.type) {}
  return state;
}